module.exports = __WEBPACK_EXTERNAL_MODULE__47666__;